import { createAccountView, forgotPasswordView, loginView } from '@common/Customer/constants/customerAuthViews';
import { VIEW_TITLES } from '../constants/constants';

const getViewTitle = view => VIEW_TITLES[view] || 'default';

export const getCurrentNavigation = (view, currentNav) => {
    if ([createAccountView, forgotPasswordView, loginView].includes(view)) {
        return {
            name: getViewTitle(view),
            lvl: 1
        };
    }

    return currentNav;
};
